import type { DashboardSpec } from "@services/housien/dashboards";
import i18n from "@/shared/i18n";

/** The translated title of a default dashboard, read on every access. */
function defaultTitle(id: string): string {
  return i18n.t(`dashboards.defaults.${id}`, { ns: "features/assistant" });
}

/**
 * Default dashboard SPECS shown on the list page until a broker saves their
 * own. Each spec is a title plus an ordered list of supported dimensions; the
 * numbers are NEVER stored here — opening a dashboard recomputes them live from
 * the backend aggregation route. These dimensions are all in the
 * `aggregate_properties` / `build_dashboard` enum, so every panel resolves to
 * real server-computed buckets.
 *
 * Reconciliation note (CHAT contract): once the CHAT worker lands the
 * assistant's "Salvar painel" affordance + the `features/dashboards` backend
 * persistence, these defaults are replaced by a live
 * `GET /agencies/{id}/dashboards` read. The list page already renders from a
 * `DashboardSpec[]`, so the swap is a data-source change only.
 */
export const DEFAULT_DASHBOARDS: DashboardSpec[] = [
  {
    id: "overview-portfolio",
    get title() {
      return defaultTitle("overview-portfolio");
    },
    dimensions: ["bedrooms", "category", "city"],
    updatedAt: "2026-10-31T00:00:00Z",
  },
  {
    id: "by-location",
    get title() {
      return defaultTitle("by-location");
    },
    dimensions: ["city", "neighborhood", "state"],
    updatedAt: "2026-10-31T00:00:00Z",
  },
  {
    id: "by-transaction",
    get title() {
      return defaultTitle("by-transaction");
    },
    dimensions: ["transaction_type", "category"],
    updatedAt: "2026-10-31T00:00:00Z",
  },
];
